export enum StatusAtendimento {
  ContatoInicial,
  Aberto,
  EmAnalise,
  EmAtendimento,
  AguardandoCliente,
  AguardandoAssinatura,
  Fechado,
  Agendado,
  Cancelado
}
